import { Type } from '@angular/core';
import { AbstractControl } from '@angular/forms';

export interface ReportGroupsDynamicFilterControl<T = any> {
  name: string;
  ctrl: AbstractControl<T>;
  /* explanation: its a work around to select an initial selectedItem in the ui-dropdown-list.
  
  The DropdownListComponent.selected field overrides value that were set by DropdownListComponent.writeValue(),
  so 'visually' we see an item set through the DropdownListComponent.selected, but the form model has the one set by the DropdownListComponent.writeValue().
  This resulst in a difference between UI and a real form model.
  todo:
  To remove this not obvious flag, the DropdownListComponent.selected should be fixed */
  overrideDropdownListSelected?: {
    enabled: boolean;
    inputName: string;
  };
}

export interface ReportGroupsDynamicFilter {
  fieldName: string;
  component: Type<any>;
  controls: Array<() => ReportGroupsDynamicFilterControl>;
  inputs: Record<string, any>;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  createControlValueFromApiPayload?: (...args: Array<any>) => unknown;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  createApiPayloadFromControlValue?: (...args: Array<any>) => unknown;
}

export enum DynamicFilterOptions {
  None = 'None',
  True = 'True',
  False = 'False',
  Active = 'Active',
  Inactive = 'Inactive',
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Removed = 'Removed',
  Gas = 'Gas',
  Water = 'Water',
  Electricity = 'Electricity',
  Meter = 'Meter',
  MTU = 'MTU',
  DCU = 'DCU',
  BaseStation = 'BaseStation',
  ExactaGuard = 'ExactaGuard',
  RDD = 'RDD',
  RMD = 'RMD'
}

export interface CreateFilterOptions {
  fieldName: string;
  items: DynamicFilterOptions[];
  defaultItem: DynamicFilterOptions | DynamicFilterOptions[];
}
